import { StyleSheet, View } from 'react-native';

const TopNavigation = ({ children, style }) => {

    return (
        <View
            style={[ styles.container, style ]}>

            { children }
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#FFF',
    },

    titleContainer: {
        flex: 1,
        flexDirection: 'column',
    },

    title: {
        fontSize: 18,
        fontWeight: 'bold',
    },
    subtitle: {
        fontSize: 14,
        color: '#666',
    },
})

export default TopNavigation;